import React from 'react';
import { isEmpty } from 'lodash';
import { Form as FinalForm } from 'react-final-form';
import { Form as Form1C } from '@1c/ui';

type Props = {
  onSubmit: (values: any) => void;
  validate?: any;
  children: any;
  submitting?: boolean;
  pristine?: boolean;
  values?: boolean;
  initialValues: {};
  setSubmit?: any;
  ref?: any;
  mutators?: any;
  layout?: 'vertical' | 'horizontal' | 'inline';
  id?: string;
};

const Form: React.FC<Props> = React.forwardRef(
  (
    { onSubmit, validate = () => {}, initialValues = {}, children, setSubmit, mutators, ...props },
    ref: any
  ) => {
    const { layout = 'horizontal' } = props;
    return (
      <FinalForm
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
        subscription={{
          values: props?.values ?? false, //if true will decrease form speed
          submitting: props?.submitting ?? false,
          pristine: props?.pristine ?? false,
          valid: true,
        }}
        mutators={mutators ?? {}}
      >
        {({ handleSubmit, ...restProps }) => {
          ref && (ref.current = handleSubmit);

          return (
            <Form1C id={props.id} onSubmit={handleSubmit} layout={layout}>
              {!isEmpty(restProps) ? children(restProps) : children}
            </Form1C>
          );
        }}
      </FinalForm>
    );
  }
);

export default React.memo(Form);
